(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/kyc-qa/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/kyc-qa/assets/javascripts/init.js');
"use strict";


(function (svs) {
  'use strict';

  svs.components.kyc_qa = svs.components.kyc_qa || {};
  let branding = svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR';
  if (svs.core.config.data.svsconfig.site === 'momang') {
    branding = 'MOMANG';
  }
  svs.components.kyc_qa.show = function (callback) {
    const qaDialog = new svs.ui.dialog.Confirm({
      icon: 'information',
      actions: [{
        title: 'Stäng',
        callback() {
          var _qaDialog$close;
          qaDialog === null || qaDialog === void 0 || (_qaDialog$close = qaDialog.close) === null || _qaDialog$close === void 0 || _qaDialog$close.call(qaDialog);
          typeof callback === 'function' && callback();
        }
      }],
      area: svs.ui.dialog.area.POPUP,
      branding: svs.ui.dialog.branding[branding],
      title: 'Frågor och svar om penningtvätt',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        text: svs.components.kyc_qa.templates.kyc_qa(),
        type: svs.ui.dialog.message.TEXT
      }]
    });
    svs.ui.dialog.api.add(qaDialog);
  };
})(svs);

 })(window);